module.exports = __webpack_public_path__ + "static/img/headbg.ea7defa.gif";


//////////////////
// WEBPACK FOOTER
// ./static/img/headbg.gif
// module id = MuMm
// module chunks = 2